import { useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  Typography,
  useTheme,
  SxProps,
  Stack,
} from "@mui/material";
import { Icon } from "@iconify/react";

import { Strings } from "@app/constants";
import { useResponsive } from "@app/hooks";

import { SortDropdownProps } from "../modules/product-list-page/types";

const SortDropdown = ({
  shortOptions,
  value,
  onChange,
  containerStyle,
  menuItemContainerStyle,
  showShotsBy,
}: SortDropdownProps) => {
  const isMobile = useResponsive("down", "sm");
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (val: string) => {
    onChange(val);
    handleClose();
  };

  return (
    <>
      <Button
        onClick={handleClick}
        endIcon={<Icon icon={open ? "mdi:chevron-up" : "mdi:chevron-down"} />}
        sx={{
          textTransform: "none",
          border: 1,
          borderColor: theme.palette.grey[300],
          borderRadius: 1,
          color: theme.palette.primary.main,
          fontWeight: 500,
          width: "100%",
          height: isMobile ? 45 : 55,
          fontSize: isMobile ? "0.875rem" : "1rem",
          ...containerStyle,
        }}
      >
        {showShotsBy && Strings.productDetail.shortsBy}{" "}
        {
          shortOptions?.find((option) => option.value === value)?.label || value
        }

      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          marginTop: 2,
          "& .MuiPaper-root": {
            width: isMobile ? "100%" : 225,
            maxWidth: isMobile ? "90%" : "auto",
            ...menuItemContainerStyle,
          },
        }}
      >
        {shortOptions?.map((shortOptions) => (
          <MenuItem
            key={shortOptions?.value}
            onClick={() => handleSelect(shortOptions?.value)}
            selected={shortOptions?.value === value}
            sx={{
              borderRadius: 1,
            }}
          >
            <Typography
              sx={{
                color:
                  shortOptions?.value === value
                    ? theme.palette.primary.main
                    : "inherit",
                fontFamily: "Work Sans",
                fontSize: isMobile ? "0.9rem" : "1rem",
              }}
            >
              {shortOptions?.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export { SortDropdown };
